export function hasAuthCookie() {
    return document.cookie.includes('auth=');
}
//# sourceMappingURL=tokenOrCookie.js.map